/* Brightwipe — theme interactions */
(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', init);

  function init() {
    initHeaderScroll();
    initMobileMenu();
    initGallery();
    initFAQ();
    initDescToggle();
  }

  function initHeaderScroll() {
    var header = document.querySelector('[data-bw-header]');
    if (!header) return;
    var onScroll = function () {
      if (window.scrollY > 10) {
        header.classList.add('is-scrolled');
      } else {
        header.classList.remove('is-scrolled');
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initMobileMenu() {
    var btn = document.querySelector('[data-bw-hamburger]');
    var menu = document.querySelector('[data-bw-mobile-menu]');
    var iconOpen = document.querySelector('[data-bw-icon-open]');
    var iconClose = document.querySelector('[data-bw-icon-close]');
    if (!btn || !menu) return;

    btn.addEventListener('click', function () {
      var open = menu.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (iconOpen && iconClose) {
        iconOpen.style.display = open ? 'none' : 'block';
        iconClose.style.display = open ? 'block' : 'none';
      }
    });

    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        menu.classList.remove('is-open');
        btn.setAttribute('aria-expanded', 'false');
        if (iconOpen && iconClose) {
          iconOpen.style.display = 'block';
          iconClose.style.display = 'none';
        }
      });
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-bw-gallery]').forEach(function (gallery) {
      var mainImg = gallery.querySelector('[data-bw-gallery-main]');
      var thumbs = gallery.querySelectorAll('[data-bw-gallery-thumb]');
      if (!mainImg || !thumbs.length) return;

      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var src = thumb.getAttribute('data-src');
          var alt = thumb.getAttribute('data-alt') || '';
          if (!src) return;
          mainImg.style.opacity = '0';
          setTimeout(function () {
            mainImg.src = src;
            mainImg.alt = alt;
            mainImg.style.opacity = '1';
          }, 120);
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
    });
  }

  function initDescToggle() {
    document.querySelectorAll('[data-bw-desc]').forEach(function (wrap) {
      var btn = wrap.querySelector('[data-bw-desc-toggle]');
      var text = wrap.querySelector('[data-bw-desc-text]');
      if (!btn || !text) return;
      btn.addEventListener('click', function () {
        var clamped = text.classList.toggle('is-clamped');
        btn.setAttribute('aria-expanded', clamped ? 'false' : 'true');
        btn.textContent = clamped ? 'Read more' : 'Read less';
      });
    });
  }

  function initFAQ() {
    document.querySelectorAll('[data-bw-faq-q]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-bw-faq-item]');
        if (!item) return;
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    });
  }

})();
